import { AppLoader } from './AppLoader';
export default AppLoader;
